import { firebase } from "../config/configureFirebase";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  uploadBytesResumable,
} from "firebase/storage";
// JavaScript function to upload an image to Firebase Storage
export const uploadImage = async (e) => {
  const { storage } = firebase;
  console.log("wrokign till here")
  let file = e;
  if (file) {
    console.log("wrokign till here too")
    const storageRef = ref(
      storage,
      `images/${file.name}${new Date().toISOString()}`
    );

    try {
      // Upload the file to Firebase Storage
      console.log("wrokign till here too too")

      await uploadBytesResumable(storageRef, file);
      console.log("wrokign till here too 3")

      let image = await getDownloadURL(storageRef);
      console.log("wrokign till here too 4")

      // profile.licenseImage = image;
      console.log("Image uploaded successfully!", image);
      return image;
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  }
};

// module.exports = { uploadImage };
